import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50493c5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "registeruser__form__wrapper" }
const _hoisted_2 = { class: "registeruser__form__title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "registeruser__form__col" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "E-mail", -1))
const _hoisted_6 = { class: "registeruser__form__button" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "pi pi-spin pi-spinner"
}
const _hoisted_9 = {
  key: 1,
  class: "registeruser__form__message"
}
const _hoisted_10 = {
  key: 2,
  class: "registeruser__form__message"
}
const _hoisted_11 = { style: {"display":"flex","align-items":"center","gap":"1rem"} }
const _hoisted_12 = { class: "pi pi-info-circle" }
const _hoisted_13 = {
  key: 3,
  class: "registeruser__form__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldInput = _resolveComponent("FieldInput")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('registryuser.title')), 1),
    (_ctx.registerUserStatus === _ctx.RegisterUserRequestStatus.WithoutStatus)
      ? (_openBlock(), _createElementBlock("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('registryuser.firstname')), 1),
              _createVNode(_component_FieldInput, {
                name: "firstName",
                type: "text",
                modelValue: _ctx.user.firstName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.firstName) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('registryuser.lastname')), 1),
              _createVNode(_component_FieldInput, {
                name: "secondName",
                type: "text",
                modelValue: _ctx.user.secondName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.secondName) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _hoisted_5,
              _createVNode(_component_FieldInput, {
                name: "email",
                type: "email",
                modelValue: _ctx.user.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.email) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('registryuser.password')), 1),
              _createVNode(_component_FieldInput, {
                name: "password",
                autocomplete: "new-password",
                type: "password",
                modelValue: _ctx.user.password,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.password) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('registryuser.confirmpassword')), 1),
              _createVNode(_component_FieldInput, {
                name: "confirm_password",
                autocomplete: "new-password",
                type: "password",
                modelValue: _ctx.user.password,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.password) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.Cancel && _ctx.Cancel(...args)))
            }, _toDisplayString(_ctx.$t('menu.cancel')), 1),
            _createElementVNode("button", {
              disabled: !_ctx.isValid || _ctx.isRegistering,
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.RegisterUser && _ctx.RegisterUser(...args)))
            }, _toDisplayString(_ctx.$t('menu.register')), 9, _hoisted_7),
            (_ctx.isRegistering)
              ? (_openBlock(), _createElementBlock("i", _hoisted_8))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.registerUserStatus === _ctx.RegisterUserRequestStatus.OK)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('registryuser.registryok')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('registryuser.registryok2')), 1),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.GoLogin && _ctx.GoLogin(...args)))
          }, "Login")
        ]))
      : _createCommentVNode("", true),
    (_ctx.registerUserStatus === _ctx.RegisterUserRequestStatus.UserRegistered)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('registryuser.userregistered1')), 1),
            _withDirectives(_createElementVNode("i", _hoisted_12, null, 512), [
              [
                _directive_tooltip,
                'INGECON SUN Monitor, INGECON SUN Planner',
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('registryuser.userregistered2')), 1),
          _createElementVNode("button", {
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.GoLogin && _ctx.GoLogin(...args)))
          }, "Login")
        ]))
      : _createCommentVNode("", true),
    (_ctx.registerUserStatus === _ctx.RegisterUserRequestStatus.Error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('registryuser.error')), 1),
          _createElementVNode("button", {
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.Retry && _ctx.Retry(...args)))
          }, _toDisplayString(_ctx.$t('menu.retry')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}